import { render, staticRenderFns } from "./wasteEntry.vue?vue&type=template&id=4cacbd8b"
import script from "./wasteEntry.vue?vue&type=script&lang=js"
export * from "./wasteEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports